/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'close': {
    width: 11,
    height: 11,
    viewBox: '0 0 11 11',
    data: '<path pid="0" _fill="currentColor" d="M5.5 4.793L1.854 1.146a.5.5 0 10-.708.708L4.793 5.5 1.146 9.146a.5.5 0 10.708.708L5.5 6.207l3.646 3.647a.5.5 0 00.708-.708L6.207 5.5l3.647-3.646a.5.5 0 00-.708-.708L5.5 4.793z"/>'
  }
})
